import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, CircularProgress, Alert, Paper } from '@mui/material';
import axios from 'axios';

const DirectAPITest = () => {
  const [testResults, setTestResults] = useState({});
  const [loading, setLoading] = useState(false);

  const runTests = async () => {
    setLoading(true);
    setTestResults({});

    const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
    
   
    const tests = [
      {
        name: 'Health Check',
        url: `${API_BASE}/health`,
        method: 'GET'
      },
      {
        name: 'Get All Products',
        url: `${API_BASE}/products`,
        method: 'GET'
      },
      {
        name: 'Get Product 1',
        url: `${API_BASE}/products/1`,
        method: 'GET'
      }
    ];

    const results = {};

    for (const test of tests) {
      try {
        
        const response = await axios({
          method: test.method,
          url: test.url,
          timeout: 5000
        });
        
        results[test.name] = {
          status: '✅ SUCCESS',
          code: response.status,
          data: response.data
        };
      } catch (error) {
        results[test.name] = {
          status: '❌ FAILED',
          error: error.message,
          code: error.response?.status || 'N/A',
          fullError: error
        };
      }
    }

    setTestResults(results);
    setLoading(false);
  };


  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h3" sx={{ mb: 3 }}>🧪 Direct API Test</Typography>
      
      <Paper sx={{ p: 3, mb: 3, backgroundColor: '#f5f5f5' }}>
        <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
          API URL: <strong>{process.env.REACT_APP_API_URL || 'http://localhost:5000/api'}</strong>
        </Typography>
      </Paper>

      <Button 
        variant="contained" 
        onClick={runTests}
        disabled={loading}
        sx={{ mb: 3 }}
      >
        {loading ? 'Testing...' : 'Run Tests'}
      </Button>

      {loading && <CircularProgress />}

      <Box sx={{ mt: 3 }}>
        {Object.entries(testResults).map(([testName, result]) => (
          <Paper key={testName} sx={{ p: 2, mb: 2 }}>
            <Typography variant="h6">{testName}</Typography>
            <Typography variant="body2" color={result.status.includes('SUCCESS') ? 'success.main' : 'error.main'}>
              {result.status}
            </Typography>
            {result.code && (
              <Typography variant="body2">Code: {result.code}</Typography>
            )}
            {result.data && (
              <Box sx={{ mt: 1, p: 1, backgroundColor: '#f0f0f0', borderRadius: 1 }}>
                <Typography variant="caption" sx={{ fontFamily: 'monospace' }}>
                  {JSON.stringify(result.data, null, 2).substring(0, 200)}...
                </Typography>
              </Box>
            )}
            {result.error && (
              <Typography variant="body2" color="error">{result.error}</Typography>
            )}
          </Paper>
        ))}
      </Box>
    </Box>
  );
};

export default DirectAPITest;
